export default "__VITE_ASSET__C7Orqfx4__"